import { useQuery } from '@tanstack/react-query';
import { downloadFile } from '../api/file-upload.service';

interface UseFileDownloadOptions {
  enabled?: boolean;
  onSuccess?: (data: { presignedUrl: string; mimeType: string; fileId: number }) => void;
  onError?: (error: Error) => void;
}

export const useFileDownload = (
  fileId: number | null | undefined,
  options: UseFileDownloadOptions = {}
) => {
  const query = useQuery({
    queryKey: ['file-download', fileId],
    queryFn: async () => {
      if (!fileId) {
        throw new Error('File ID is required');
      }
      return downloadFile(fileId);
    },
    enabled: !!fileId && (options.enabled !== false),
    staleTime: 10 * 60 * 1000, // 10 minutes in milliseconds
    gcTime: 15 * 60 * 1000, // 15 minutes - keep in cache slightly longer
    retry: 2,
    refetchOnWindowFocus: false,
    refetchOnMount: false,
  });

  return query;
};
